import { range } from "../../utils/array-utils.js";
import { BaseComponent } from "../../base.component.js";

/**
 * @typedef {object} _GridSize
 * @property {number} x
 * @property {number} y
 */

/**
 * @typedef {RenderableProps} _AbGrid_Props
 * @property {_GridSize} size
 */
export function AbGrid({ size, children }) {
  const compChildren = [];
  let filledRows = 0;
  children.forEach((child, i) => {
    const row = Math.floor(i / size.x);
    if (!compChildren[row]) {
      filledRows = filledRows + 1;
      compChildren[row] = [];
    }
    compChildren[row].push(child);
  });

  const rowHeight = (100 / filledRows).toFixed(2);
  return (
    <div className="ab-grid">
      {range(size.y).map(row =>
        compChildren[row] &&
        // just couldn't make it work only with flex - for centering vertically, when there are less rows than max
        <div className='ab-row' style={`height: ${rowHeight}%`}>
          {range(size.x).map(col =>
            compChildren[row][col] &&
            <div className="ab-col">
              <div className="ab-item">
                <div className="ab-item-inside">
                  {compChildren[row][col]}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
